<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="payHeaders" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table
            :headers="payHeaders"
            :items="payOrders"
            :options.sync="pagination"
            :server-items-length="totalPayOrders"
            :footer-props="items_per_page"
            :must-sort="true"
            
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.CustomerName }}</td>
                <td>{{ item.StoreVNImportDate | display_date }}</td>
                <td class="text-end font-weight-bold">{{item.TotalAmountVND | currency}}</td>
                <td class="text-end">{{ item.Deposit | currency}}</td>
                <td class="text-end">{{ item.PayLeft | currency}}</td>
                <td class="text-end">{{ item.Wallet | currency}}</td>
                <td class="text-end font-weight-bold">{{ item.Remain | currency}}</td>
                <td class="text-end">{{ item.OrderNumber | currency}}</td>
                <td class="text-end">{{ item.OrderNumberTran | currency}}</td>
                <td class="text-center pay-button">
                  <v-btn text icon color="red lighten-2" @click="openPayDetail(item.ID)">
                    <v-icon>fa-check-double</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-dialog v-model="dialogPayDetail" max-width="700px">
            <v-card>
              <v-card-title>
                <span class="title">Thanh toán đơn hàng</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md pa-0>
                  <v-layout row wrap>
                    <v-flex lg12>
                      <div>Tài khoản: DL{{payOrderDetail.CustomerID}} - {{payOrderDetail.CustomerName}}</div>
                    </v-flex>
                    <v-flex lg12>
                        <v-autocomplete label="Địa chỉ" v-model="selectedAddressID" :items="addressBooks" :item-text="getAddressText" item-value="ID" @change="onSelectedAddress"></v-autocomplete>
                    </v-flex>
                    <v-flex lg12>
                       <v-text-field  v-model="paymentRequest.ReceiverName" label="Người nhận" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg12>
                       <v-text-field  v-model="paymentRequest.ReceiverPhone" label="Điện thoại" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg12>
                       <v-text-field  v-model="paymentRequest.ReceiverAddress" label="Địa chỉ" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg12 class="font-weight-bold">
                      <div>Số đơn thanh toán: {{selected.length | currency}}</div>
                    </v-flex>
                    <v-flex lg12>
                      <v-data-table
                        :headers="orderHeader"
                        :items="payOrderDetail.Orders"
                        :mobile-breakpoint="100"
                        :items-per-page="1000"
                        :hide-default-footer="true"
                        item-key="ID"
                        show-select
                        v-model="selected"
                      >
                        <template v-slot:item="{ item, isSelected, select }">
                          <tr :active="isSelected">
                            <td @click="select(!isSelected)">
                              <v-checkbox primary hide-details :input-value="isSelected"></v-checkbox>
                            </td>
                            <td>
                              <a target="_blank" :href="(item.OrderType == 1 ? '/don-hang/chi-tiet/' : '/ky-gui/') + item.ID">{{(item.OrderType == 1 ? 'MD' : 'KG') +item.ID}}</a>
                            </td>
                            <td>{{ item.PackageCode }}</td>
                            <td v-if="item.Status != orderStatus.da_xuat_kho && item.Status != orderStatus.khieu_nai" :class="item.Deliverable ? 'red--text' : ''">{{item.Deliverable ? 'Cho xuất kho' : ''}}</td>
                            <td v-else>{{item.Status | order_status}}</td>
                            <td
                              class="text-end font-weight-bold"
                            >{{ item.TotalAmountVND | currency}}</td>
                            <td class="text-end">{{ item.Deposit | currency}}</td>
                            <td class="text-end">{{ item.PayLeft | currency}}</td>
                          </tr>
                        </template>
                        <template v-slot:body.append>
                          <tr>
                            <td colspan="4" class="font-weight-bold">Tổng</td>
                            <td class="text-end font-weight-bold">{{totalAmount | currency}}</td>
                            <td class="text-end font-weight-bold">{{totalDeposit | currency}}</td>
                            <td class="text-end font-weight-bold">{{totalPayLeft | currency}}</td>
                          </tr>
                          <tr>
                            <td colspan="6" class="font-weight-bold">Phí ship</td>
                            <td class="text-end font-weight-bold">
                              <h-currency-input
                                
                                class="fee-cn-footer"
                                v-model="shipFee"
                                :decimal="0"
                              ></h-currency-input>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="6" class="font-weight-bold"><v-text-field label="Phí khác" v-model="feeOtherName" ></v-text-field></td>
                            <td class="text-end font-weight-bold">
                              <h-currency-input
                                
                                class="fee-cn-footer"
                                v-model="feeOther"
                                :decimal="0"
                              ></h-currency-input>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="6" class="font-weight-bold">Số dư ví</td>
                            <td
                              class="text-end font-weight-bold"
                            >{{payOrderDetail.Wallet | currency}}</td>
                          </tr>
                          <tr>
                            <td colspan="6" class="font-weight-bold">Cần trả thêm</td>
                            <td class="text-end font-weight-bold">{{totalRemain | currency}}</td>
                          </tr>
                          <tr>
                            <td colspan="6" class="font-weight-bold"><v-select label="Hình thức thanh toán" v-model="method" :items="rechargeMethods" item-text="name" item-value="value" ></v-select></td>
                            <td class="text-end font-weight-bold">
                              <h-currency-input
                                
                                class="fee-cn-footer"
                                v-model="inputCash"
                                :decimal="0"
                              ></h-currency-input>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-3 white--text" @click="dialogPayDetail = false">Đóng</v-btn>
                <v-btn
                  color="black darken-3 white--text"
                  @click="saveDeliverOrder(0)"
                  v-if="customerServiceRole || paymentRole || adminRole"
                  :disabled="selected.length == 0"
                >Huỷ xuất kho</v-btn>
                <v-btn
                  color="red darken-3 white--text"
                  @click="saveDeliverOrder(1)"
                  v-if="customerServiceRole || paymentRole || adminRole"
                  :disabled="selected.length == 0"
                >Xuất trước</v-btn>
                <v-btn
                  color="green darken-3 white--text"
                  @click="savePayOrder"
                  v-if="customerServiceRole || paymentRole || adminRole"
                  :disabled="selected.length == 0 || isSaving"
                >Thanh toán</v-btn>
                <v-btn absolute top right class="mt-5" @click="printPayOrder">
                  <v-icon color="red darken-2" class="mr-2">fa-print</v-icon>In đơn
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="loading" fullscreen>
            <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
              <v-layout justify-center align-center>
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-layout>
            </v-container>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
    <div class="pt-5">
      <h3>Lịch sử thanh toán</h3>
    </div>
    <payment-history class="px-0"></payment-history>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import Vue from 'vue';
import _ from "lodash";
import { currency } from "@/commons/currency";
import moment from "moment";
import { sendErrorNotice, getCurrentTime } from "@/commons/utils";
import PaymentHistoryList from "@/views/PaymentHistory/PaymentHistoryList.vue";
import { request_list, print_export_receipt_order } from '@/commons/hpod';
export default {
  components: {
    "hpo-filter": Filtering,
    "payment-history": PaymentHistoryList
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      clearSelect: true,
      timeout: 2000,
      payMode: false,
      search: "",
      feeOtherName: "",
      feeOther: 0,
      inputCash: 0,
      shipFee: 0,
      method: configs.RECHARGE_TYPE.Cash,
      selectedAddressID: 0,
      shippingMethod: "",
      rechargeMethods: _.filter(configs.RECHARGE_METHODS, function(o) { return o.value >= 90; }),
      payHeaders: [
        {
          text: "Khách hàng",
          value: "CustomerName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Ngày nhập kho",
          value: "StoreVNImportDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Tổng tiền",
          value: "TotalAmountVND",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Đã trả",
          value: "Deposit",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tiền thiếu",
          value: "PayLeft",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tài khoản",
          value: "Wallet",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cần trả thêm",
          value: "Remain",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Số đơn hàng",
          value: "OrderNumber",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Đơn đang vận chuyển",
          value: "OrderNumberTran",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          align: "center",
          filterable: false,
          sortable: false
        }
      ],
      orderHeader: [
        {
          text: "Mã đơn hàng",
          value: "ID",
          right: false
        },
        {
          text: "Mã lô",
          value: "PackageCode",
          right: false
        },
        {
          text: "Trạng thái",
          value: "Deliverable",
          right: false
        },
        {
          text: "Tổng tiền",
          value: "TotalAmountVND",
          align: "end"
        },
        {
          text: "Đã trả",
          value: "Deposit",
          align: "end"
        },
        {
          text: "Còn thiếu",
          value: "PayLeft",
          align: "end"
        }
      ],
      selected: [],
      pagination: { ...configs.PAGINATION, sortBy: ["StoreVNImportDate"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "payorder_list",      
      filterConditions: [],
      quickFilterConditions: [],
      dialogPayDetail: false,
      phoneNumber: '',
      orderStatus: configs.ORDER_STATUS_ENUM,
      isSaving: false,
      paymentRequest: {ReceiverName: '', ReceiverPhone: '', ReceiverAddress: ''}
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    },
    payOrderDetail() {
      if (this.clearSelect && this.payOrderDetail && this.payOrderDetail.Orders) {
        this.selected = this.payOrderDetail.Orders.slice();
      }
      this.phoneNumber = this.payOrderDetail ? this.payOrderDetail.PhoneNumber : '';
      Vue.nextTick(() => {
        document.title = `DL${this.payOrderDetail.CustomerID}_PTT${moment().format('YYYYMMDD')}`;
      });
      this.$store.dispatch("addressBook/getList", {
        filter: [{
          column: "UID",
          value: this.payOrderDetail.CustomerID,
          condition: "equal"
        }]
      });
      this.clearSelect = true;
    },
    addressBooks() {
      if(this.addressBooks.length > 0) {
        this.selectedAddressID = this.addressBooks[0].ID;
        this.paymentRequest.ReceiverName = this.addressBooks[0].Receiver;
        this.paymentRequest.ReceiverPhone = this.addressBooks[0].Phone;
        this.paymentRequest.ReceiverAddress = this.addressBooks[0].Address;
      }
    },
    dialogPayDetail() {
      this.feeOther = 0;
      this.inputCash = 0;
      this.shipFee = 0;
    }
  },
  computed: {
    ...mapState("payOrder", {
      payOrders: "all",
      totalPayOrders: "total",
      payOrderDetail: "selectedItem",
      loading: "loading",
    }),
    ...mapState({
      addressBooks: state => state.addressBook.all.data,
    }),
    pages() {
      if (this.options.rowsPerPage == null || this.options.totalItems == null)
        return 0;

      return Math.ceil(this.options.totalItems / this.options.rowsPerPage);
    },
    totalAmount() {
      return _.sumBy(this.selected, "TotalAmountVND");
    },
    totalDeposit() {
      return _.sumBy(this.selected, "Deposit");
    },
    totalOldPayLeft() {
      return _.sumBy(_.filter(this.selected, p => p.Status == 9), "PayLeft");
    },
    totalNewPayLeft() {
      return _.sumBy(_.filter(this.selected, p => p.Status != 9), "PayLeft");
    },
    totalPayLeft() {
      return _.sumBy(this.selected, "PayLeft");
    },
    totalFeeOther() {
      return _.sumBy(this.selected, "FeeOther");
    },
    totalRemain() {
      return this.payOrderDetail.Wallet >= this.totalPayLeft + this.shipFee + this.feeOther
        ? 0
        : this.totalPayLeft + this.shipFee + this.feeOther - this.payOrderDetail.Wallet;
    },
    customerServiceRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
    },
    paymentRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("payOrder/getPayOrderList", param);
    },
    toggleAll() {
      if (this.selected.length === this.payOrderDetail.Orders.length)
        this.selected = [];
      else this.selected = this.payOrderDetail.Orders.slice();
    },
    openPayDetail(customerId) {
      this.$store.dispatch("payOrder/getPayOrderDetail", customerId);
      this.dialogPayDetail = true;
      this.isSaving = false;
    },
    saveDeliverOrder(deliverable = 1) {
      let order_ids = _.map(_.filter(this.selected, {'OrderType': 1}), "ID");
      if(order_ids.length > 0) {
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: order_ids,
          Deliverable: deliverable
        });
      }
      let deposit_ids = _.map(_.filter(this.selected, {'OrderType': 2}), "ID");
      if(deposit_ids.length > 0) {
        this.$store.dispatch("deposit/updateMultiple", {
          OrderIDs: deposit_ids,
          Deliverable: deliverable
        });
      }
      // this.$store.dispatch("orderTransaction/updateMultiple", {
      //   OrderIDs: order_ids,
      //   DepositIDs: deposit_ids,
      //   ShippingInfo: `${this.payOrderDetail.CustomerName} - ${this.phoneNumber} - ${this.payOrderDetail.Address}`,
      //   ShippingMethod: this.shippingMethod
      // });
      // this.saveNewRequest(1);
      this.dialogPayDetail = false;
      setTimeout(this.filter_data, 300);
    },
    savePayOrder() {
      if (this.selected.length == 0) {
        sendErrorNotice("Hãy chọn hóa đơn cần thanh toán");
        return;
      }
      if (this.totalRemain > this.inputCash) {
        sendErrorNotice("Hãy nhập thêm tiền mặt");
        return;
      }
      if(this.isSaving) {
        return;
      }
      this.isSaving = true;
      this.$store.dispatch("payOrder/updatePayOrder", {
        order_ids: _.map(_.filter(this.selected, {'OrderType': 1}), "ID"),
        deposit_ids: _.map(_.filter(this.selected, {'OrderType': 2}), "ID"),
        cash: this.inputCash,
        method: this.method,
        totalPayLeft: this.totalPayLeft,
        shipFee: this.shipFee,
        feeOther: this.feeOther,
        feeOtherName: this.feeOtherName,
        customer_id: this.payOrderDetail.CustomerID,
        shippingMethod: this.shippingMethod
      }).then((r) => {
        this.isSaving = false;
        if(r.status !== 200) {
          return;
        }
        this.$store.dispatch("orderTransaction/updateMultiple", {
          OrderIDs: _.map(_.filter(this.selected, {'OrderType': 1}), "ID"),
          DepositIDs: _.map(_.filter(this.selected, {'OrderType': 2}), "ID"),
          ShippingInfo: `${this.phoneNumber} - ${this.payOrderDetail.Address}`,
          ShippingMethod: this.shippingMethod
        });
        // this.saveNewRequest(1);
      });
      this.dialogPayDetail = false;
      setTimeout(this.filter_data, 300);
    },
    printPayOrder() {
      this.clearSelect = false;
      this.$store.dispatch("payOrder/getPayOrderDetail", this.payOrderDetail.CustomerID).then(() => {
        let OrderIDs = _.map(this.selected, "ID");
        var param = {
            pagination: {...configs.PAGINATION, itemsPerPage: 10000, sortBy: ["OrderID"]},
            filter: [{
                column: "UID",
                value: this.payOrderDetail.CustomerID,
                condition: "equal"
            },
            {
                column: "Status",
                value: [4,5],
                condition: "in"
            },
            {
                column: "OrderID",
                value: OrderIDs,
                condition: "in"
            }]
        };
        request_list('order_transactions', ret => {
          if(ret.data.length > 0) {
            let packages = ret.data;
            const frame_printing = print_export_receipt_order({'CustomerID': this.payOrderDetail.CustomerID, 'CustomerName': this.payOrderDetail.CustomerName, 'PhoneNumber': this.phoneNumber, 'Address': this.payOrderDetail.Address, 'PayLeft': this.totalPayLeft, 'OldPayLeft': this.totalOldPayLeft, 'NewPayLeft': this.totalNewPayLeft, 'Wallet': this.payOrderDetail.Wallet, 'Remain': this.totalRemain, 'FeeOther': this.totalFeeOther, 'Orders': this.selected}, packages, true, true);
            var iframe = document.getElementById('print_frame');
            var doc = document.getElementById('print_frame').contentWindow.document;
            doc.open();
            doc.write(frame_printing);
            doc.close();
            // Đợi tất cả hình ảnh được tải xong trước khi in
            var images = iframe.contentWindow.document.images;
            var loadedImages = 0;

            function checkAndPrint() {
                loadedImages++;
                if (loadedImages === images.length) {
                  console.log('Tất cả hình ảnh đã tải, tiến hành in');
                    // Tất cả hình ảnh đã tải, tiến hành in
                    iframe.contentWindow.print();
                }
            }
            
            // Nếu không có ảnh, in ngay lập tức
            if (images.length === 0) {
                iframe.contentWindow.print();
            } else {
                // Thêm sự kiện 'load' cho từng hình ảnh
                for (var i = 0; i < images.length; i++) {
                    images[i].onload = checkAndPrint;
                    images[i].onerror = checkAndPrint; // Xử lý trường hợp ảnh không tải được
                }
            }
            // setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
          }
          else {
            sendErrorNotice('Danh sách đơn hàng đã xuất kho.')
            return;
          }
        }, Vue.http, param, this.$store.state.authentication.token);
      });
    },
    applyFilter(filterConditions) {
      this.pagination = {
        ...configs.PAGINATION,
        sortBy: this.pagination.sortBy,
        sortDesc: this.pagination.sortDesc
      };
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.pagination = {
        ...configs.PAGINATION,
        sortBy: this.pagination.sortBy,
        sortDesc: this.pagination.sortDesc
      };
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    getAddressText(item) {
      return `${item.Receiver} - ${item.Phone}`
    },
    onSelectedAddress() {
      const addr = _.find(this.addressBooks, {'ID': this.selectedAddressID});
      if(addr) {
        this.paymentRequest.UID = this.payOrderDetail.CustomerID;
        this.paymentRequest.Username = this.payOrderDetail.CustomerName;
        this.paymentRequest.ReceiverName = addr.Receiver;
        this.paymentRequest.ReceiverPhone = addr.Phone;
        this.paymentRequest.ReceiverAddress = addr.Address;
      }
    },
    saveNewRequest(isPayLaster) {
      let orders = this.selected;
      if(orders.length == 0) {
          return;
      }
      if(!this.selectedAddressID) {
          sendErrorNotice('Hãy chọn địa chỉ giao hàng.')
          return;
      }
      this.paymentRequest.UID = this.payOrderDetail.CustomerID;
      this.paymentRequest.Username = this.payOrderDetail.CustomerName;
      this.paymentRequest.TotalAmount = _.sumBy(orders, "TotalAmountVND");
      this.paymentRequest.TotalPayment = _.sumBy(orders, "Deposit");
      this.paymentRequest.TotalOrder = this.selected.length;
      this.paymentRequest.Status = 1;
      this.$store.dispatch("paymentRequest/setDetail", {
          data: {
              ...this.paymentRequest,
              IsPayLaster: isPayLaster,
              Orders: orders
          },
          id: 0
      });
    },
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>

<style>
.pay-button {
  width: 135px;
}

.fee-cn-footer .v-text-field .v-label--active {
  right: 0px !important;
  left: auto !important;
}

.fee-cn-footer .v-text-field__slot input {
  text-align: right !important;
  font-size: 0.9em !important;
}
</style>
